import { MatIconModule } from '@angular/material/icon';
import { NgClass, NgForOf, NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { IsNumberPipe } from '@pipes/is-number/is-number.pipe';
import { PaginationComponent } from '@abstract/components/pagination.component';

@Component({
  selector: 'app-table-pagination',
  standalone: true,
  templateUrl: './table-pagination.component.html',
  styleUrls: ['./table-pagination.component.scss'],
  imports: [NgIf, MatIconModule, MatButtonModule, NgClass, NgForOf, IsNumberPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TablePaginationComponent extends PaginationComponent {}
